import {
  ApartmentOutlined,
  PartitionOutlined,
  BarsOutlined,
} from "@ant-design/icons";

const CHART_TYPES = [
  {
    label: "Вертикально",
    key: "vertical",
    icon: <ApartmentOutlined />,
  },
  {
    label: "Горизонтально",
    key: "horizontal",
    icon: <PartitionOutlined />,
  },
  {
    label: "Дерево",
    key: "tree",
    icon: <BarsOutlined />,
  },
];

const CHART_COLORS = [
  "#ff7b7b",
  "#ffa940",
  "#ffec3d",
  "#bae637",
  "#36cfc9",
  "#4096ff",
  "#b37feb",
  "#ff85c0",
  "#ff7a45",
  "#ffc53d",
  "#73d13d",
  "#85a5ff",
];

export { CHART_TYPES, CHART_COLORS };
